import React from 'react';
import { Input } from 'antd';
import { t } from '../i18n';
import { useFilterLayoutStyles } from '../utils/languageUtils';

interface InputFilterItemProps {
    label: string | null;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    placeholder?: string;
    required?: boolean;
    forceHorizontal?: boolean; // 强制水平布局，如果为 true 则无论语言都使用水平布局
    maxLength?: number;
    showCount?: boolean;
}

const InputFilterItem: React.FC<InputFilterItemProps> = ({ 
    label, 
    value, 
    onChange, 
    className,
    spanClassName,
    disabled,
    placeholder,
    required = false,
    forceHorizontal,
    maxLength,
    showCount
}) => {
    // 使用公共 Hook 获取布局样式
    const { containerClassName, labelClassName, inputContainerClassName } = useFilterLayoutStyles(spanClassName, className, forceHorizontal);
    
    return (
        <div className={containerClassName}>
            <span className={labelClassName}>
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </span>
            <div className={inputContainerClassName}>
                <Input 
                    placeholder={placeholder !== undefined ? placeholder : t('components.input.typeIn')}
                    value={value}
                    allowClear
                    onChange={onChange}
                    disabled={disabled}
                    className="w-full"
                    maxLength={maxLength}
                    showCount={showCount}
                />
            </div>
        </div>
    );
};

export default InputFilterItem; 